import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const WifiIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
    {...props}
  >

    <path
      fill="currentColor"
      d="M10 10.167C10.4602 10.167 10.833 10.5398 10.833 11C10.833 11.4602 10.4602 11.833 10 11.833C9.5398 11.833 9.16699 11.4602 9.16699 11C9.16699 10.5398 9.5398 10.167 10 10.167ZM10 7.06738C11.3852 7.06746 12.6544 7.57072 13.6318 8.4043C13.8838 8.61923 13.9139 8.99788 13.6992 9.25C13.4842 9.5018 13.1055 9.5322 12.8535 9.31738C12.085 8.66197 11.0892 8.26668 10 8.2666C8.91086 8.26666 7.91495 8.66209 7.14648 9.31738C6.89438 9.53211 6.51574 9.50196 6.30078 9.25C6.08586 8.99799 6.11539 8.61938 6.36719 8.4043C7.34467 7.57063 8.6147 7.06744 10 7.06738ZM10 3.7334C12.369 3.73346 14.5246 4.65632 16.123 6.16113C16.3638 6.38814 16.375 6.7676 16.1484 7.00879C15.9213 7.25006 15.5411 7.26133 15.2998 7.03418C13.9152 5.73081 12.0511 4.93268 10 4.93262C7.94888 4.93268 6.08481 5.73082 4.7002 7.03418C4.45893 7.26132 4.07969 7.25004 3.85254 7.00879C3.62545 6.76753 3.6367 6.38827 3.87793 6.16113C5.47631 4.65646 7.6311 3.73346 10 3.7334ZM10 0.400391C13.5788 0.400506 16.8005 1.93409 19.042 4.37793C19.2658 4.62215 19.249 5.00166 19.0049 5.22559C18.7607 5.44901 18.381 5.43249 18.1572 5.18848C16.1335 2.98221 13.2285 1.59972 10 1.59961C6.77137 1.59973 3.86556 2.98205 1.8418 5.18848C1.61787 5.43241 1.23829 5.44925 0.994141 5.22559C0.750297 5.00172 0.733572 4.62208 0.957031 4.37793C3.19853 1.93397 6.42112 0.400507 10 0.400391Z"
    />
  </SvgIcon>
)
